import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useCustomerDatabase from '../hooks/useCustomerDatabase'
import useActivityLog from '../hooks/useActivityLog'
import Button from '../components/Button'
import InputField from '../components/InputField'
import { useToast } from '../context/ToastContext'

const CustomerAdminPage = () => {
  const { showToast } = useToast()
  const navigate = useNavigate()
  const { customers, createCustomer } = useCustomerDatabase()
  const { logAction } = useActivityLog()
  const [newName, setNewName] = useState('')

  const handleCreate = async () => {
    if (!newName.trim()) {
      showToast('Customer name is required', 'red')
      return
    }
    try {
      await createCustomer(newName.trim())
      await logAction('create_customer', { customerName: newName.trim() })
      showToast('Customer created', 'green')
      setNewName('')
    } catch (err) {
      console.error(err)
      showToast('Failed to create customer', 'red')
    }
  }

  return (
    <div className='p-4'>
      <h1 className='text-4xl mb-4'>Customer Admin</h1>

      <div className='flex flex-row items-end mb-6'>
        <InputField
          containerClassName=''
          labelFor='newCustomerName'
          type='text'
          id='newCustomerName'
          name='newCustomerName'
          onChange={(e) => setNewName(e.target.value)}
          value={newName}
          placeholder='Customer name'
        >
          New Customer
        </InputField>
        <Button onClick={handleCreate}>Create</Button>
      </div>

      <table className='w-full text-left text-sm'>
        <thead>
          <tr className='border-b'>
            <th className='p-2'>Name</th>
            <th className='p-2'>Emails</th>
            <th className='p-2'>Actions</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((c) => (
            <tr key={c.id} className='border-b hover:bg-gray-100'>
              <td className='p-2'>{c.name}</td>
              <td className='p-2'>{(c.emails || []).join(', ') || '—'}</td>
              <td className='p-2'>
                <Button onClick={() => navigate(`/customers/${c.id}`)}>Edit</Button>
              </td>
            </tr>
          ))}
          {customers.length === 0 && (
            <tr>
              <td colSpan={3} className='p-4 text-center text-gray-500'>No customers yet.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default CustomerAdminPage
